import { useEffect } from 'react'
import { usePreferences } from '../preferences/PreferencesContext'
import { useOnlineStatus } from '../hooks/useOnlineStatus'
import { scheduleTextPack } from '../lib/offline/textPack'
import { backfillSurahBytes } from '../lib/offline/offlineStore'

/**
 * Renders nothing. After first paint (idle time), warms the offline text
 * pack for the active edition and backfills byte accounting for legacy
 * downloads. Re-runs when the edition changes or connectivity returns.
 */
export function OfflineBootstrap() {
  const { prefs } = usePreferences()
  const online = useOnlineStatus()

  useEffect(() => {
    if (!online) return
    const run = () => {
      scheduleTextPack(prefs.edition)
      void backfillSurahBytes()
    }
    // Feature-detect via `typeof ... === 'function'` (matches the pattern
    // used for matchMedia elsewhere) rather than `'requestIdleCallback' in
    // window`: TypeScript's DOM lib declares requestIdleCallback as an
    // always-present method, so an `in` check narrows the fallthrough branch
    // to `never` and breaks the setTimeout fallback at compile time, even
    // though the API is genuinely absent at runtime in jsdom and older
    // Safari.
    if (typeof window.requestIdleCallback === 'function') {
      const id = window.requestIdleCallback(run, { timeout: 10_000 })
      return () => window.cancelIdleCallback(id)
    }
    const id = window.setTimeout(run, 3_000)
    return () => window.clearTimeout(id)
  }, [prefs.edition, online])

  return null
}
